export * from './cuentaetiqueta-autocomplete.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/cuentaetiqueta-autocomplete/index.ts